import React from 'react'
import { Card, Spinner } from '@shopify/polaris'
import LappaPolarisDataTableShell from 'components/LappaPolarisDataTableShell'
import NoDataMessage from 'components/NoDataMessage/NoDataMessage'
import { ReactComponent as ReminderImg } from 'img/illustrations/general/reminder-img.svg'
import { getPeriodTypeForVat } from '../utils/periodUtils'
import { getStatusForVat } from '../utils/statusUtils'
import _ from 'lodash'

const SalesTaxReturnsSection = ({ declarationsSalesTax, fetchingSalesTax, user, t, navigate }) => {
	const rows = declarationsSalesTax ? declarationsSalesTax.items : []

	return (
		<Card sectioned={fetchingSalesTax || _.isEmpty(rows)}>
			{fetchingSalesTax ? (
				<Spinner />
			) : (
				<>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
						<h2 style={{ fontSize: 18, fontWeight: '600' }}>{t("home.title.salesTaxRet")}</h2>
						<button
							style={{
								maxHeight: '20px',
								borderColor: 'transparent',
								boxShadow: 'none',
								background: 'transparent',
								height: 'auto',
								color: 'rgba(44, 110, 203, 1)',
								fontSize: 14,
								fontWeight: 400,
								cursor: 'pointer'
							}}
							onClick={() => navigate("/tax-returns")}
						>
							{t("home.viewAll")}
						</button>
					</div>
					{!_.isEmpty(rows) && !fetchingSalesTax && (
						<>
							<br />
							<div className='border-top table-dashboard-returns'>
								<LappaPolarisDataTableShell
									columnContentTypes={[
										"text",
										"text",
										"text",
										"numeric",
									]}
									headings={[]}
									rows={[...rows].map((rowData) => [
										rowData.state.name,
										getPeriodTypeForVat(rowData.period_type, t),
										`${rowData.period} ${rowData.period_type} ${rowData.period_year}`,
										getStatusForVat(rowData.status, t),
									])}
								/>
							</div>
						</>
					)}
					{_.isEmpty(rows) && !fetchingSalesTax && (
						<div>
							<NoDataMessage
								title={t("home.noDataYet")}
								description={t("home.addTaxReturnsToSeeData")}
								buttonText={
									user.vat_returns_show_in_menu
										? t("home.addTaxReturns")
										: null
								}
								Image={ReminderImg}
								style={{ height: "auto" }}
								onClick={() => navigate("/tax-returns/create-return")}
							/>
						</div>
					)}
				</>
			)}
		</Card>
	)
}

export default SalesTaxReturnsSection

